<template>
  <div>
    <main-header></main-header>
    <div id="custom-header" ref="projects">
      <img src="../assets/images/banner/img_banner3.jpg" />
      <div class="custom-header-content">
        <div class="container">
          <h1 class="page-title">Projects</h1>
        </div>
      </div>
    </div>
    <div id="content" class="site-content global-layout-no-sidebar">
      <div class="container">
        <div class="inner-wrapper">
          <div id="primary" class="content-area">
            <div id="main" class="site-main">
              <!-- OUR PROJECTS -->
              <div class="section section-portfolio">
                <div class="container">
                  <div class="section-title-wrap">
                    <h2 class="section-title">OUR PROJECTS</h2>
                    <span class="divider"></span>
                    <p class="section-subtitle">
                      To furnish many of the most desired luxury residential and
                      commercial development in Singapore and Oversea
                    </p>
                  </div>
                  <div class="portfolio-main-wrapper">
                 <!--   <nav class="portfolio-filter">
                      <ul>
                        <li>
                          <a
                            href="#"
                            data-filter="*"
                            :class="{ active: currentProject == 'all' }"
                            @click="currentProject = 'all'"
                            ><span></span>All</a
                          >
                        </li>
                        <li>
                          <a
                            href="#"
                            data-filter=".singapore"
                            :class="{ active: currentProject == 'singapore' }"
                            @click="currentProject = 'singapore'"
                            >singapore</a
                          >
                        </li>
                        <li>
                          <a
                            href="#"
                            data-filter=".overseas"
                            :class="{ active: currentProject == 'overseas' }"
                            @click="currentProject = 'overseas'"
                            >overseas</a
                          >
                        </li>
                      </ul>
                    </nav> -->
                    <!--  class="masonry-wrapper portfolio-container row-fluid wow fadeInUp" -->
                    <div id="portfolio" class="portfolio-container">
                      <div
                        class="portfolio-item-content"
                        v-for="(item, index) of project_options"
                        :key="index"
                        :class="item.className"
                        @click="getImages(item.imgArr, item.text)"
                      >
                        <div class="portfolio-item-img">
                          <img
                            :src="item.img"
                            alt="Portfolio"
                            class="portfolio-thumb"
                            style="width: 600px; height: 300px; object-fit: cover; object-position: center;"
                          />
                        </div>
                        <div class="Portfolio_desc">
                          <img :src="item.logImg" style="max-width: 100px; max-height: 80px; width: auto; height: auto; object-fit: contain;" />
                          <div class="more" @click="show_img = true">MORE></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <main-foot></main-foot>
    <PrettyPhoto
      v-if="show_img"
      @close="close"
      :imgs="imgs"
      :imgIndex="0"
      :photo_text="photo_text"
    ></PrettyPhoto>
    <PageScroller></PageScroller>
  </div>
</template>
<script>
import MainHeader from "../components/MainHeader";
import MainFoot from "../components//MainFoot";
import PageScroller from "../components/PageScroller";
import PrettyPhoto from "../components/PrettyPhoto";

import img1 from "../assets/images/project/1-Forett/img_forett_封面.jpg";
import img2 from "../assets/images/project/2-Queens Peak/img_QueensPeak_封面.jpg";
import img3 from "../assets/images/project/3-Sceneca Residence, Tanah Merah/img_Sceneca_封面图.jpg";
import img4 from "../assets/images/project/4-One Bernam/img_OneBernam_封面图.jpg";
import img5 from "../assets/images/project/5-Phonix/img_Phonix_封面图.jpg";
import img6 from "../assets/images/project/6-Tampines Street 62 Tenet EC/img_Tampines_封面图.jpg";
import img7 from "../assets/images/project/7-Yishu EC North Gaia/img_Yishu_封面图.jpg";
import img8 from "../assets/images/project/8-Jadescape/img_Jadescape_封面图.jpg";
import img9 from "../assets/images/project/9-skyvill/1.png";
import img10 from "../assets/images/project/GRAND DUNMAN/0.png";
import img11 from "../assets/images/project/HILLHAVEN/0.png";
import img12 from "../assets/images/project/MAYFAIR MODERN/0.png";
import img13 from "../assets/images/project/NORMANTON PARK/0.png";
import img14 from "../assets/images/project/PROVENCE/0.png";
import img15 from "../assets/images/project/THE COMMODORE/0.png";
import img16 from "../assets/images/project/THE HILL/0.png";

import logImg1 from "../assets/images/project/1-Forett/Logo1_FORETT.png";
import logImg2 from "../assets/images/project/2-Queens Peak/Logo2_Queens.png";
import logImg3 from "../assets/images/project/3-Sceneca Residence, Tanah Merah/Logo3_Sceneca.png";
import logImg4 from "../assets/images/project/4-One Bernam/Logo4_OneBernam.png";
import logImg5 from "../assets/images/project/5-Phonix/Logo5_Phoenix.png";
import logImg6 from "../assets/images/project/6-Tampines Street 62 Tenet EC/Logo6_tenet.png";
import logImg7 from "../assets/images/project/7-Yishu EC North Gaia/Logo7_north_gaia.png";
import logImg8 from "../assets/images/project/8-Jadescape/Logo8_jadescape.png";
import logImg9 from "../assets/images/project/9-skyvill/Logo_skyvilla.png";
import logImg10 from "../assets/images/project/GRAND DUNMAN/logo.png"; 
import logImg11 from "../assets/images/project/HILLHAVEN/logo.png";
import logImg12 from "../assets/images/project/MAYFAIR MODERN/logo.png";
import logImg13 from "../assets/images/project/NORMANTON PARK/logo.png";
import logImg14 from "../assets/images/project/PROVENCE/logo.png";
import logImg15 from "../assets/images/project/THE COMMODORE/logo.png";
import logImg16 from "../assets/images/project/THE HILL/logo.png";

const imgArr1 = [
  require("../assets/images/project/1-Forett/img_forett_1.jpg"),
  require("../assets/images/project/1-Forett/img_forett_2.jpg"),
  require("../assets/images/project/1-Forett/img_forett_3.jpg"),
  require("../assets/images/project/1-Forett/img_forett_4.jpg"),
  require("../assets/images/project/1-Forett/img_forett_5.jpg"),
  require("../assets/images/project/1-Forett/img_forett_6.jpg"),
  require("../assets/images/project/1-Forett/img_forett_7.jpg"),
  require("../assets/images/project/1-Forett/img_forett_8.jpg"),
  require("../assets/images/project/1-Forett/img_forett_9.jpg"),
  require("../assets/images/project/1-Forett/img_forett_10.jpg"),
  require("../assets/images/project/1-Forett/img_forett_11.jpg"),
  require("../assets/images/project/1-Forett/img_forett_12.jpg"),
];
const imgArr2 = [
  require("../assets/images/project/2-Queens Peak/img_QueensPeak_1.jpg"),
  require("../assets/images/project/2-Queens Peak/img_QueensPeak_2.jpg"),
  require("../assets/images/project/2-Queens Peak/img_QueensPeak_3.jpg"),
  require("../assets/images/project/2-Queens Peak/img_QueensPeak_4.jpg"),
  require("../assets/images/project/2-Queens Peak/img_QueensPeak_5.jpg"),
  require("../assets/images/project/2-Queens Peak/img_QueensPeak_6.jpg"),
  require("../assets/images/project/2-Queens Peak/img_QueensPeak_7.jpg"),
  require("../assets/images/project/2-Queens Peak/img_QueensPeak_8.jpg"),
  require("../assets/images/project/2-Queens Peak/img_QueensPeak_9.jpg"),
  require("../assets/images/project/2-Queens Peak/img_QueensPeak_10.jpg"),
  require("../assets/images/project/2-Queens Peak/img_QueensPeak_11.jpg"),
  require("../assets/images/project/2-Queens Peak/img_QueensPeak_12.jpg"),
];
const imgArr3 = [
  require("../assets/images/project/3-Sceneca Residence, Tanah Merah/img_Sceneca_1.jpg"),
  require("../assets/images/project/3-Sceneca Residence, Tanah Merah/img_Sceneca_2.jpg"),
  require("../assets/images/project/3-Sceneca Residence, Tanah Merah/img_Sceneca_3.jpg"),
  require("../assets/images/project/3-Sceneca Residence, Tanah Merah/img_Sceneca_4.jpg"),
  require("../assets/images/project/3-Sceneca Residence, Tanah Merah/img_Sceneca_5.jpg"),
  require("../assets/images/project/3-Sceneca Residence, Tanah Merah/img_Sceneca_6.jpg"),
  require("../assets/images/project/3-Sceneca Residence, Tanah Merah/img_Sceneca_7.jpg"),
  require("../assets/images/project/3-Sceneca Residence, Tanah Merah/img_Sceneca_8.jpg"),
  require("../assets/images/project/3-Sceneca Residence, Tanah Merah/img_Sceneca_9.jpg"),
  require("../assets/images/project/3-Sceneca Residence, Tanah Merah/img_Sceneca_10.jpg"),
  require("../assets/images/project/3-Sceneca Residence, Tanah Merah/img_Sceneca_11.jpg"),
  require("../assets/images/project/3-Sceneca Residence, Tanah Merah/img_Sceneca_12.jpg"),
];
const imgArr4 = [
  require("../assets/images/project/4-One Bernam/img_OneBernam_1.jpg"),
  require("../assets/images/project/4-One Bernam/img_OneBernam_2.jpg"),
  require("../assets/images/project/4-One Bernam/img_OneBernam_3.jpg"),
  require("../assets/images/project/4-One Bernam/img_OneBernam_4.jpg"),
  require("../assets/images/project/4-One Bernam/img_OneBernam_5.jpg"),
  require("../assets/images/project/4-One Bernam/img_OneBernam_6.jpg"),
  require("../assets/images/project/4-One Bernam/img_OneBernam_7.jpg"),
  require("../assets/images/project/4-One Bernam/img_OneBernam_8.jpg"),
  require("../assets/images/project/4-One Bernam/img_OneBernam_9.jpg"),
  require("../assets/images/project/4-One Bernam/img_OneBernam_10.jpg"),
  require("../assets/images/project/4-One Bernam/img_OneBernam_11.jpg"),
  require("../assets/images/project/4-One Bernam/img_OneBernam_12.jpg"),
  require("../assets/images/project/4-One Bernam/img_OneBernam_13.jpg"),
  require("../assets/images/project/4-One Bernam/img_OneBernam_14.jpg"),
  require("../assets/images/project/4-One Bernam/img_OneBernam_15.jpg"),
  require("../assets/images/project/4-One Bernam/img_OneBernam_16.jpg"),
  require("../assets/images/project/4-One Bernam/img_OneBernam_17.jpg"),
  require("../assets/images/project/4-One Bernam/img_OneBernam_18.jpg"),
  require("../assets/images/project/4-One Bernam/img_OneBernam_19.jpg"),
  require("../assets/images/project/4-One Bernam/img_OneBernam_20.jpg"),
  require("../assets/images/project/4-One Bernam/img_OneBernam_21.jpg"),
  require("../assets/images/project/4-One Bernam/img_OneBernam_22.jpg"),
  require("../assets/images/project/4-One Bernam/img_OneBernam_23.jpg"),
];
const imgArr5 = [
  require("../assets/images/project/5-Phonix/img_Phonix_1.jpg"),
  require("../assets/images/project/5-Phonix/img_Phonix_2.jpg"),
  require("../assets/images/project/5-Phonix/img_Phonix_3.jpg"),
  require("../assets/images/project/5-Phonix/img_Phonix_4.jpg"),
  require("../assets/images/project/5-Phonix/img_Phonix_5.jpg"),
  require("../assets/images/project/5-Phonix/img_Phonix_6.jpg"),
  require("../assets/images/project/5-Phonix/img_Phonix_7.jpg"),
  require("../assets/images/project/5-Phonix/img_Phonix_8.jpg"),
  require("../assets/images/project/5-Phonix/img_Phonix_9.jpg"),
  require("../assets/images/project/5-Phonix/img_Phonix_10.jpg"),
  require("../assets/images/project/5-Phonix/img_Phonix_11.jpg"),
  require("../assets/images/project/5-Phonix/img_Phonix_12.jpg"),
  require("../assets/images/project/5-Phonix/img_Phonix_13.jpg"),
];
const imgArr6 = [
  require("../assets/images/project/6-Tampines Street 62 Tenet EC/img_Tampines_1.jpg"),
  require("../assets/images/project/6-Tampines Street 62 Tenet EC/img_Tampines_2.jpg"),
  require("../assets/images/project/6-Tampines Street 62 Tenet EC/img_Tampines_3.jpg"),
  require("../assets/images/project/6-Tampines Street 62 Tenet EC/img_Tampines_4.jpg"),
  require("../assets/images/project/6-Tampines Street 62 Tenet EC/img_Tampines_5.jpg"),
  require("../assets/images/project/6-Tampines Street 62 Tenet EC/img_Tampines_6.jpg"),
  require("../assets/images/project/6-Tampines Street 62 Tenet EC/img_Tampines_7.jpg"),
  require("../assets/images/project/6-Tampines Street 62 Tenet EC/img_Tampines_8.jpg"),
  require("../assets/images/project/6-Tampines Street 62 Tenet EC/img_Tampines_9.jpg"),
  require("../assets/images/project/6-Tampines Street 62 Tenet EC/img_Tampines_10.jpg"),
  require("../assets/images/project/6-Tampines Street 62 Tenet EC/img_Tampines_11.jpg"),
  require("../assets/images/project/6-Tampines Street 62 Tenet EC/img_Tampines_12.jpg"),
  require("../assets/images/project/6-Tampines Street 62 Tenet EC/img_Tampines_13.jpg"),
  require("../assets/images/project/6-Tampines Street 62 Tenet EC/img_Tampines_14.jpg"),
];

const imgArr7 = [
  require("../assets/images/project/7-Yishu EC North Gaia/img_Yishu_1.jpg"),
  require("../assets/images/project/7-Yishu EC North Gaia/img_Yishu_2.jpg"),
  require("../assets/images/project/7-Yishu EC North Gaia/img_Yishu_3.jpg"),
  require("../assets/images/project/7-Yishu EC North Gaia/img_Yishu_4.jpg"),
  require("../assets/images/project/7-Yishu EC North Gaia/img_Yishu_5.jpg"),
  require("../assets/images/project/7-Yishu EC North Gaia/img_Yishu_6.jpg"),
  require("../assets/images/project/7-Yishu EC North Gaia/img_Yishu_7.jpg"),
  require("../assets/images/project/7-Yishu EC North Gaia/img_Yishu_8.jpg"),
  require("../assets/images/project/7-Yishu EC North Gaia/img_Yishu_9.jpg"),
  require("../assets/images/project/7-Yishu EC North Gaia/img_Yishu_10.jpg"),
  require("../assets/images/project/7-Yishu EC North Gaia/img_Yishu_11.jpg"),
  require("../assets/images/project/7-Yishu EC North Gaia/img_Yishu_12.jpg"),
];

const imgArr8 = [
  require("../assets/images/project/8-Jadescape/img_Jadescape_1.jpg"),
  require("../assets/images/project/8-Jadescape/img_Jadescape_2.jpg"),
  require("../assets/images/project/8-Jadescape/img_Jadescape_3.jpg"),
  require("../assets/images/project/8-Jadescape/img_Jadescape_4.jpg"),
  require("../assets/images/project/8-Jadescape/img_Jadescape_5.jpg"),
  require("../assets/images/project/8-Jadescape/img_Jadescape_6.jpg"),
  require("../assets/images/project/8-Jadescape/img_Jadescape_7.jpg"),
  require("../assets/images/project/8-Jadescape/img_Jadescape_8.jpg"),
  require("../assets/images/project/8-Jadescape/img_Jadescape_9.jpg"),
  require("../assets/images/project/8-Jadescape/img_Jadescape_10.jpg"),
  require("../assets/images/project/8-Jadescape/img_Jadescape_11.jpg"),
  require("../assets/images/project/8-Jadescape/img_Jadescape_12.jpg"),
  require("../assets/images/project/8-Jadescape/img_Jadescape_13.jpg"),
  require("../assets/images/project/8-Jadescape/img_Jadescape_14.jpg"),
];
const imgArr9 = [
  require("../assets/images/project/9-skyvill/2.jpg"),
  require("../assets/images/project/9-skyvill/3.jpg"),
  require("../assets/images/project/9-skyvill/4.jpg"),
  require("../assets/images/project/9-skyvill/5.jpg"),
];
const imgArr10 = [
  require("../assets/images/project/GRAND DUNMAN/1.jpg"),
  require("../assets/images/project/GRAND DUNMAN/2.jpg"),
  require("../assets/images/project/GRAND DUNMAN/3.jpg"),
  require("../assets/images/project/GRAND DUNMAN/4.jpg"),
  require("../assets/images/project/GRAND DUNMAN/5.png"),
  require("../assets/images/project/GRAND DUNMAN/7.jpg"),
  require("../assets/images/project/GRAND DUNMAN/8.jpg"),
  require("../assets/images/project/GRAND DUNMAN/9.jpg"),
  require("../assets/images/project/GRAND DUNMAN/10.jpg"),
  require("../assets/images/project/GRAND DUNMAN/11.jpg"),
  require("../assets/images/project/GRAND DUNMAN/12.png"),
  require("../assets/images/project/GRAND DUNMAN/13.png"),
  require("../assets/images/project/GRAND DUNMAN/14.jpg"),
  require("../assets/images/project/GRAND DUNMAN/15.jpg"),
  require("../assets/images/project/GRAND DUNMAN/16.jpg"),
  require("../assets/images/project/GRAND DUNMAN/17.jpg"),
  require("../assets/images/project/GRAND DUNMAN/18.jpg"),
  require("../assets/images/project/GRAND DUNMAN/19.jpg"),
  require("../assets/images/project/GRAND DUNMAN/20.jpg"),
  require("../assets/images/project/GRAND DUNMAN/21.jpg"),
  require("../assets/images/project/GRAND DUNMAN/22.jpg"),
  require("../assets/images/project/GRAND DUNMAN/23.jpg"),
  require("../assets/images/project/GRAND DUNMAN/24.jpg"),
  require("../assets/images/project/GRAND DUNMAN/25.jpg"),
  require("../assets/images/project/GRAND DUNMAN/26.jpg"),
  require("../assets/images/project/GRAND DUNMAN/27.jpg"),
  require("../assets/images/project/GRAND DUNMAN/28.jpg"),
  require("../assets/images/project/GRAND DUNMAN/29.jpg"),
  require("../assets/images/project/GRAND DUNMAN/30.jpg"),
  require("../assets/images/project/GRAND DUNMAN/31.jpg"),
  require("../assets/images/project/GRAND DUNMAN/32.jpg"),
  require("../assets/images/project/GRAND DUNMAN/33.jpg"),
];
const imgArr11 = [
  require("../assets/images/project/HILLHAVEN/1.png"),
  require("../assets/images/project/HILLHAVEN/2.png"),
  require("../assets/images/project/HILLHAVEN/3.png"),
  require("../assets/images/project/HILLHAVEN/4.png"),
  require("../assets/images/project/HILLHAVEN/5.png"),
  require("../assets/images/project/HILLHAVEN/6.jpg"),
  require("../assets/images/project/HILLHAVEN/7.png"),
  require("../assets/images/project/HILLHAVEN/8.png"),
  require("../assets/images/project/HILLHAVEN/9.png"),
  require("../assets/images/project/HILLHAVEN/10.png"),
  require("../assets/images/project/HILLHAVEN/11.png"),
  require("../assets/images/project/HILLHAVEN/12.jpg"),
  require("../assets/images/project/HILLHAVEN/13.png"),
]
const imgArr12 = [
  require("../assets/images/project/MAYFAIR MODERN/1.png"),
  require("../assets/images/project/MAYFAIR MODERN/2.png"),
  require("../assets/images/project/MAYFAIR MODERN/3.png"),
  require("../assets/images/project/MAYFAIR MODERN/4.png"),
  require("../assets/images/project/MAYFAIR MODERN/5.png"),
  require("../assets/images/project/MAYFAIR MODERN/6.png"),
  require("../assets/images/project/MAYFAIR MODERN/7.png"),
  require("../assets/images/project/MAYFAIR MODERN/8.png"),
  require("../assets/images/project/MAYFAIR MODERN/9.png"),
  require("../assets/images/project/MAYFAIR MODERN/10.png"),
  require("../assets/images/project/MAYFAIR MODERN/11.png"),
  require("../assets/images/project/MAYFAIR MODERN/12.png"),
]
const imgArr13 = [
  require("../assets/images/project/NORMANTON PARK/1.jpg"),
  require("../assets/images/project/NORMANTON PARK/2.jpg"),
  require("../assets/images/project/NORMANTON PARK/3.jpg"),
  require("../assets/images/project/NORMANTON PARK/4.jpg"),
  require("../assets/images/project/NORMANTON PARK/5.jpg"),
  require("../assets/images/project/NORMANTON PARK/6.jpg"),
  require("../assets/images/project/NORMANTON PARK/7.jpg"),
  require("../assets/images/project/NORMANTON PARK/8.jpg"),
  require("../assets/images/project/NORMANTON PARK/9.jpg"),
  require("../assets/images/project/NORMANTON PARK/10.jpg"),
  require("../assets/images/project/NORMANTON PARK/11.jpg"),
  require("../assets/images/project/NORMANTON PARK/12.jpg"),
  require("../assets/images/project/NORMANTON PARK/13.jpg"),
]
const imgArr14 = [
  require("../assets/images/project/PROVENCE/1.png"),
  require("../assets/images/project/PROVENCE/2.png"),
  require("../assets/images/project/PROVENCE/3.png"),
  require("../assets/images/project/PROVENCE/4.png"),
  require("../assets/images/project/PROVENCE/5.png"),
  require("../assets/images/project/PROVENCE/6.png"),
  require("../assets/images/project/PROVENCE/7.png"),
  require("../assets/images/project/PROVENCE/8.png"),
  require("../assets/images/project/PROVENCE/9.png"),
  require("../assets/images/project/PROVENCE/10.png"),
  require("../assets/images/project/PROVENCE/11.png"),
]
const imgArr15 = [
  require("../assets/images/project/THE COMMODORE/1.png"),
  require("../assets/images/project/THE COMMODORE/2.png"),
  require("../assets/images/project/THE COMMODORE/3.png"),
  require("../assets/images/project/THE COMMODORE/4.png"),
  require("../assets/images/project/THE COMMODORE/5.png"),
  require("../assets/images/project/THE COMMODORE/6.png"),
  require("../assets/images/project/THE COMMODORE/7.png"),
  require("../assets/images/project/THE COMMODORE/8.png"),
]
const imgArr16 = [
  require("../assets/images/project/THE HILL/1.jpg"),
  require("../assets/images/project/THE HILL/2.jpg"),
  require("../assets/images/project/THE HILL/3.jpg"),
  require("../assets/images/project/THE HILL/4.jpg"),
  require("../assets/images/project/THE HILL/5.jpg"),
  require("../assets/images/project/THE HILL/6.jpg"),
  require("../assets/images/project/THE HILL/7.jpg"),
  require("../assets/images/project/THE HILL/8.jpg"),
  require("../assets/images/project/THE HILL/9.jpg"),
  require("../assets/images/project/THE HILL/10.jpg"),
]
export default {
  name: "Projects",
  created() {
    let self = this;
  },
  data() {
    return {
      currentProject: "all",
      show_img: false,
      bigimages: [],
      project_options: [
        {
          img: img10,
          logImg: logImg10,
          className: "singapore",
          imgArr: imgArr10,
          text:
            "Grand Dunman comprises 1,008 residential units, offering a wide selection of 2, 3, 4 and 5 bedroom apartments, together with exclusive penthouse units.",
        },
        {
          img: img11,
          logImg: logImg11,
          className: "singapore",
          imgArr: imgArr11,
          text:
            "Hillhaven comprises 341 residential units, featuring well-designed 2, 3 and 4 bedroom apartments to suit a variety of lifestyle needs.",
        },
        {
          img: img12,
          logImg: logImg12,
          className: "singapore",
          imgArr: imgArr12,
          text:
            "Mayfair Modern comprises 171 residential units, offering a curated mix of 1, 2, 3 and 4 bedroom apartments within an exclusive low-density development.",
        },
        {
          img: img13,
          logImg: logImg13,
          className: "singapore",
          imgArr: imgArr13,
          text:
            "Normanton Park comprises 1,862 residential units, ranging from 1 to 5 bedroom apartments, complemented by penthouse and strata terrace units.",
        },
        {
          img: img14,
          logImg: logImg14,
          className: "singapore",
          imgArr: imgArr14,
          text:
            "Provence Residence comprises 413 residential units, featuring spacious 3 and 4 bedroom apartments designed for family living.",
        },
        {
          img: img15,
          logImg: logImg15,
          className: "singapore",
          imgArr: imgArr15,
          text:
            "The Commodore comprises 219 residential units, offering a selection of 1, 2, 3, 4 and 5 bedroom apartments to cater to diverse homeowner preferences.",
        },
        {
          img: img16,
          logImg: logImg16,
          className: "singapore",
          imgArr: imgArr16,
          text:
            "The Hill @ One-North comprises 142 residential units, featuring 2, 3, 4 and 5 bedroom apartments thoughtfully designed for modern urban living.",
        },
        {
          img: img1,
          logImg: logImg1,
          className: "singapore",
          imgArr: imgArr1,
          text:
            "Forett @ Bukit Timah comprises 633 residential units, spread over two distinct residential portions. With 9 blocks of low-rise 5-storey, and 4 blocks of high-rise 9-storey, this gives the entire development a gentle visual flow when viewed from outside.",
        },
        {
          img: img2,
          logImg: logImg2,
          className: "singapore",
          imgArr: imgArr2,
          text:
            "Queens Peak condominium in Dundee Road comprises 736 well designed and smartly functional units ranging from 1 bedroom flats up to 3, 4 and 5 bedroom apartments plus 4 very spacious penthouse suites.",
        },
        {
          img: img3,
          logImg: logImg3,
          className: "singapore",
          imgArr: imgArr3,
          text:
            "Sceneca Residence is an upcoming condo development that overlooks Tanah Merah MRT station in District 16. It will be a mixed-use development comprising private residential apartments with communal facilities and retail spaces. <br>The ground level will have retail spaces measuring up to 2,000 square meters. A supermarket is allotted a minimum of 1,000 square meters, or about 10,700 square feet. There will be about 268 private residential units on the upper floors.",
        },
        {
          img: img4,
          logImg: logImg4,
          className: "singapore",
          imgArr: imgArr4,
          text:
            "One Bernam Condo – Enviable Location at the Heart of Singapore. <br>One Bernam comprises of 1 Block of 35 Storey Residential units, with a 2-Storey Commercial Mall, and a 1-Storey Serviced Apartment. There is a good mix of unit floorplan and unit sizes, from 1 Bedroom 441sqft to the ultra-luxurious 5 Bedroom Penthouse 4,306sqft.",
        },
        {
          img: img5,
          className: "singapore",
          logImg: logImg5,
          imgArr: imgArr5,
          text:
            "Built off of the former Phoenix Heights, Phoenix Residences is a brand new residence with a 99-year leasehold, in the heart of Bukit Panjang (District 23). Occupying about 59,825 square feet, Phoenix Residences sits smack on the junction at Phoenix Road and Phoenix Avenue. The private development is only available to an exclusive 72 apartment owners. ",
        },
        {
          img: img6,
          className: "singapore",
          logImg: logImg6,
          imgArr: imgArr6,
          text:
            "The Tampines Street 62 executive condominium sits on a land size of approximately 256,172.46 square feet housing an estimated of 618 residential units. Tenet EC will feature multiple unit types catering to the different needs of different family profiles. Ranging from 3 bedrooms to 5 bedrooms, buyers will definitely be able to find something suitable to fulfil their family needs.",
        },
        {
          img: img7,
          className: "singapore",
          logImg: logImg7,
          imgArr: imgArr7,
          text:
            "North Gaia Executive Condominium is set to launch in Q1 2022. A large development with 616 units located beside Symphony Suites (condo) in Yishun, District 27. Comprises of 11 blocks of 14-storey residential towers (616 units). Units size consisting of 3 bedrooms – 5 bedrooms. Units are adequately sized for growing families with higher income looking to enjoy a private gated environment for recreational and facilities.",
        },
        {
          img: img8,
          logImg: logImg8,
          className: "singapore",
          imgArr: imgArr8,
          text:
            "Jadescape Singapore – Lavish Condominium at Marymount MRT.<br>Jadescape comprises of 1,206 residential units & 6 Commercial Shops, spread of 7 Blocks of 21-23 Storey. With a large land of 408,927sqft, Jade Scape offers full condominium facilities, and lush landscaping greenery surrounding the development.",
        },
        {
          img: img9,
          logImg: logImg9,
          className: "overseas",
          imgArr: imgArr9,
          text:
            "Sky Villa comprises two 35-storey towers of luxury residential apartments in the prime district of central Phnom Penh. The property features 256 units ideal for personal or multi-generational family living. With generous residential spaces that range from 272sqm to  509sqm, this is living large at its finest. Beyond expansive spaces, each unit is thoughtfully designed to ensure that you get to enjoy  expansive views of the city and its stunning surroundings.",
        },
      ],
      imgs: [],
      photo_text: "",
    };
  },
  methods: {
    getImages(value, text) {
      this.show_img = true;
      this.imgs = value;
      this.photo_text = text;
    },
    close(e) {
      this.show_img = e;
    },
  },
  components: { MainHeader, MainFoot, PrettyPhoto, PageScroller },
};
</script>
<style lang="less" scoped>
.section-portfolio {
  .container {
    padding: 0;
  }
}
.portfolio-container {
  > div:nth-child(3n) {
    margin-right: 0px;
  }
  > div:last-child {
    .Portfolio_desc {
      img {
        width: 32px;
        height: 80px;
      }
    }
  }
}

.portfolio-item-content {
  cursor: pointer;
  float: left;
  position: relative;
  margin-bottom: 50px;
  width: 29%;
  margin-right: 25px;
  margin-left: 25px;
  background-color: #ffffff;
  box-shadow: 0px 4px 35px 0px rgba(0, 0, 0, 0.11);
}
.portfolio-item-img {
  //height: 320px;
}
.Portfolio_desc {
  display: flex;
  padding: 20px;
  height: 100px;
  align-items: center;
  .more {
    margin-left: auto;
    cursor: pointer;
    color: #0095dd;
    font-size: 18px;
    font-family: Montserrat-Regular;
    &:hover {
      color: red;
    }
  }
}

.page_scrollbar::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
  .page_scrollbar::-webkit-scrollbar-thumb {
  border-radius: 6px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #e5e5e5;
  &:hover {
    background-color: #dcdcdc;
  }
}
.page_scrollbar::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px #ffffff;
  border-radius: 0;
  background: #ffffff;
}
.page_scrollbar::-webkit-scrollbar-button {
  display: none;
}
.page_scrollbar::-webkit-scrollbar-button:vertical:end:increment,
.page_scrollbar::-webkit-scrollbar-button:vertical:start:increment {
  display: block;
  height: 5px;
  background-color: transparent;
}
.page_scrollbar::-webkit-scrollbar-thumb:vertical:hover,
::-webkit-scrollbar-thumb:horizontal:hover {
  background-color: #dcdcdc;
}
</style>
